import { PlusIcon } from '@heroicons/react/24/outline';
import {
  PencilIcon,
  ChatBubbleBottomCenterIcon
} from '@heroicons/react/24/solid';
import { useState } from 'react';
import RentItemModal from '../Modal/RentItemModal';

const users = [
  {
    name: 'Neil Sims',
    email: 'neil.sims@flowbite.com',
    dayPrice: 10,
    monthlyPrice: 200,
    yearlyPrice: 2000,
    upcomingDeals: {
      renterName: "John Tan",
      startDate: "2025-06-01",
      endDate: "2025-06-10",
    },
    status: 'Active',
  },
  {
    name: 'Neil 1',
    email: 'neil.sims@flowbite.com',
    dayPrice: 10,
    monthlyPrice: 200,
    yearlyPrice: 2000,
    upcomingDeals: {
      renterName: "John Tan",
      startDate: "2025-06-01",
      endDate: "2025-06-10",
    },
    status: 'Active',
  },
  {
    name: 'Neil Sims',
    email: 'neil.sims@flowbite.com',
    dayPrice: 10,
    monthlyPrice: 200,
    yearlyPrice: 2000,
    upcomingDeals: {
      renterName: "John Tan",
      startDate: "2025-06-01",
      endDate: "2025-06-10",
    },
    status: 'Active',
  },
  {
    name: 'Neil Sims',
    email: 'neil.sims@flowbite.com',
    dayPrice: 10,
    monthlyPrice: 200,
    yearlyPrice: 2000,
    upcomingDeals: {
      renterName: "John Tan",
      startDate: "2025-06-01",
      endDate: "2025-06-10",
    },
    status: 'Active',
  },
  {
    name: 'Neil Sims',
    email: 'neil.sims@flowbite.com',
    dayPrice: 10,
    monthlyPrice: 200,
    yearlyPrice: 2000,
    upcomingDeals: {
      renterName: "John Tan",
      startDate: "2025-06-01",
      endDate: "2025-06-10",
    },
    status: 'Active',
  },
  {
    name: 'Neil Sims',
    email: 'neil.sims@flowbite.com',
    dayPrice: 10,
    monthlyPrice: 200,
    yearlyPrice: 2000,
    upcomingDeals: {
      renterName: "John Tan",
      startDate: "2025-06-01",
      endDate: "2025-06-10",
    },
    status: 'Active',
  },
  {
    name: 'Neil Sims',
    email: 'neil.sims@flowbite.com',
    dayPrice: 10,
    monthlyPrice: 200,
    yearlyPrice: 2000,
    upcomingDeals: {
      renterName: "John Tan",
      startDate: "2025-06-01",
      endDate: "2025-06-10",
    },
    status: 'Active',
  },
  {
    name: 'Neil Sims',
    email: 'neil.sims@flowbite.com',
    dayPrice: 10,
    monthlyPrice: 200,
    yearlyPrice: 2000,
    upcomingDeals: {
      renterName: "John Tan",
      startDate: "2025-06-01",
      endDate: "2025-06-10",
    },
    status: 'Active',
  },
  {
    name: 'Neil Sims',
    email: 'neil.sims@flowbite.com',
    dayPrice: 10,
    monthlyPrice: 200,
    yearlyPrice: 2000,
    upcomingDeals: {
      renterName: "John Tan",
      startDate: "2025-06-01",
      endDate: "2025-06-10",
    },
    status: 'Active',
  },
   {
    name: 'Neil Sims',
    email: 'neil.sims@flowbite.com',
    dayPrice: 10,
    monthlyPrice: 200,
    yearlyPrice: 2000,
    upcomingDeals: {
      renterName: "John Tan",
      startDate: "2025-06-01",
      endDate: "2025-06-10",
    },
    status: 'Active',
  },
  {
    name: 'Neil Sims',
    email: 'neil.sims@flowbite.com',
    dayPrice: 10,
    monthlyPrice: 200,
    yearlyPrice: 2000,
    upcomingDeals: {
      renterName: "John Tan",
      startDate: "2025-06-01",
      endDate: "2025-06-10",
    },
    status: 'Active',
  },

  // ...more users
];

function RentItems(rentalItem) {
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
const rentalItems = rentalItem?.rentalItem || [];
  const totalPages = rentalItems ? Math.ceil(rentalItems.length / itemsPerPage) : 1;

  const currentItems = rentalItems.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) setCurrentPage(page);
  };

  return (
    <div className="w-full overflow-x-auto">
      {/* Table */}
      <table className="w-full md:min-w-full text-sm text-left">
        <thead className="bg-gray-800 text-gray-200 hidden md:table-header-group">
          <tr>
            <th className="px-4 py-3">Name</th>
            <th className="px-4 py-3">Price</th>
            <th className="px-4 py-3">Upcoming Rental</th>
          </tr>
        </thead>
        <tbody>
          {currentItems.map((item) => (
            <tr
              key={item.id}
              className="border border-gray-200 shadow-sm md:table-row block md:border-0 rounded-lg mb-4 md:mb-0 md:mx-0"
            >
              <td className="px-4 py-3 font-semibold block md:table-cell">
                <div className="flex items-center justify-between">
                  <div>{item.title}</div>
                  <button className="text-gray-600 p-2 rounded-full">
                    <PencilIcon className="w-4 h-4" />
                  </button>
                </div>
                <div className="text-xs text-gray-400">{item.location}</div>
                <div className={`inline-flex items-center text-sm font-medium mt-1`}>
                  <span className={`w-2 h-2 rounded-full mr-2 ${item.status === 'Approve' ? 'bg-green-500' : 'bg-red-500'}`}></span>
                  <span className={item.status === 'Approve' ? 'text-green-400' : 'text-red-400'}>
                    {item.status}
                  </span>
                </div>
              </td>

              <td className="px-4 py-3 text-gray-300 block md:table-cell">
                <div>
                  <div><span className="font-medium">Daily:</span> ${item.rentalDaily}</div>
                  <div><span className="font-medium">Monthly:</span> ${item.rentalMonthly}</div>
                  <div><span className="font-medium">Yearly:</span> ${item.rentalWeekly}</div>
                </div>
              </td>

              <td className="px-4 py-3 font-semibold block md:table-cell">
  {item.orders && item.orders.length > 0 ? (
    (() => {
      // filter out closed orders
      const activeOrders = item.orders.filter(order => order.status !== "Closed");

      if (activeOrders.length === 0) {
        return <div className="text-sm text-gray-400">No upcoming rentals</div>;
      }

      return activeOrders.map((order) => (
        <div key={order.id} className="flex items-center justify-between mb-2">
          <div>
            <div className="text-sm">👤 {order.userUID.id}</div>
            <div className="text-xs text-gray-400">
              {/* {order.startDate} → {order.endDate} */}
            </div>
          </div>
          <button className="text-gray-600 p-2 rounded-full">
            <ChatBubbleBottomCenterIcon className="w-4 h-4" />
          </button>
        </div>
      ));
    })()
  ) : (
    <div className="text-sm text-gray-400">No upcoming rentals</div>
  )}
</td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* Mobile Pagination */}
      <div className="flex flex-1 items-center justify-between sm:hidden mt-4">
        <button
          onClick={() => handlePageChange(currentPage - 1)}
          disabled={currentPage === 1}
          className="px-3 py-2 bg-gray-300 rounded disabled:opacity-50"
        >
          Prev
        </button>
        <span className="px-2">{currentPage} / {totalPages}</span>
        <button
          onClick={() => handlePageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
          className="px-3 py-2 bg-gray-300 rounded disabled:opacity-50"
        >
          Next
        </button>
      </div>

      {/* Desktop Pagination */}
      <div className="hidden sm:flex sm:flex-1 sm:items-center sm:justify-between mt-4">
        <div>
          <p className="text-sm text-gray-700">
            Showing <span className="font-medium">{(currentPage-1)*itemsPerPage+1}</span> to{' '}
            <span className="font-medium">{Math.min(currentPage*itemsPerPage, rentalItems.length)}</span> of{' '}
            <span className="font-medium">{rentalItems.length}</span> results
          </p>
        </div>
        <div>
          <nav aria-label="Pagination" className="isolate inline-flex -space-x-px rounded-md shadow-xs">
            <button
              onClick={() => handlePageChange(currentPage - 1)}
              disabled={currentPage === 1}
              className="relative inline-flex items-center rounded-l-md px-2 py-2 text-gray-400 hover:bg-gray-50 disabled:opacity-50"
            >
              <span className="sr-only">Previous</span>
              <svg viewBox="0 0 20 20" fill="currentColor" className="w-5 h-5">
                <path fillRule="evenodd" clipRule="evenodd" d="M11.78 5.22a.75.75 0 0 1 0 1.06L8.06 10l3.72 3.72a.75.75 0 1 1-1.06 1.06l-4.25-4.25a.75.75 0 0 1 0-1.06l4.25-4.25a.75.75 0 0 1 1.06 0Z"/>
              </svg>
            </button>

            {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => {
              if (page === 1 || page === totalPages || Math.abs(page - currentPage) <= 1) {
                return (
                  <button
                    key={page}
                    onClick={() => handlePageChange(page)}
                    aria-current={page === currentPage ? 'page' : undefined}
                    className={`relative z-10 inline-flex items-center px-4 py-2 text-sm font-semibold ${
                      page === currentPage ? 'bg-indigo-600 text-white' : 'text-gray-900 hover:bg-gray-50'
                    }`}
                  >
                    {page}
                  </button>
                );
              }
              if (Math.abs(page - currentPage) === 2 && page !== 2 && page !== totalPages-1) {
                return <span key={page} className="relative inline-flex items-center px-4 py-2 text-sm font-semibold text-gray-700">...</span>;
              }
              return null;
            })}

            <button
              onClick={() => handlePageChange(currentPage + 1)}
              disabled={currentPage === totalPages}
              className="relative inline-flex items-center rounded-r-md px-2 py-2 text-gray-400 hover:bg-gray-50 disabled:opacity-50"
            >
              <span className="sr-only">Next</span>
              <svg viewBox="0 0 20 20" fill="currentColor" className="w-5 h-5">
                <path fillRule="evenodd" clipRule="evenodd" d="M8.22 5.22a.75.75 0 0 1 1.06 0l4.25 4.25a.75.75 0 0 1 0 1.06l-4.25 4.25a.75.75 0 0 1-1.06-1.06L11.94 10 8.22 6.28a.75.75 0 0 1 0-1.06Z"/>
              </svg>
            </button>
          </nav>
        </div>
      </div>
    </div>
  );
}

export default RentItems;